import React, { useEffect } from "react";
import { Chart } from "@tanstack/charts/react";

export function ChartFrame({
    definition,
    ariaLabel,
    ariaDescription,
    height = 320,
    width,
    className,
    style,
    onReady,
    onSelect
}: {
    definition: React.ComponentProps<typeof Chart>["definition"];
    ariaLabel: string;
    ariaDescription?: string;
    height?: number;
    width?: number;
    className?: string;
    style?: React.CSSProperties;
    onReady?: () => void;
    onSelect?: (datum: any) => void;
}): React.ReactElement {
    useEffect(() => {
        if (onReady) onReady();
    }, [onReady]);

    const outerStyle: React.CSSProperties = { maxWidth: "100%", boxSizing: "border-box", ...style };
    if (typeof outerStyle.width === "undefined") {
        outerStyle.width = "100%";
    }

    return (
        <div data-testid="chart" className={className} style={outerStyle}>
            <Chart
                definition={definition}
                ariaLabel={ariaLabel}
                ariaDescription={ariaDescription}
                height={height}
                width={width}
                style={{ width: "100%", height: "100%", boxSizing: "border-box" }}
                onSelect={
                    onSelect
                        ? (point) => {
                              if (point) onSelect(point.datum);
                          }
                        : undefined
                }
            />
        </div>
    );
}
